import React, { useState, useEffect } from 'react';
import 'common/css/master.css';
import QRCode from 'qrcode';
import { getTokenId } from '../questionPaperGenerator/questionPaperGeneratorSvc';

// window.location.origin use karte hain (hardcoded prod domain nahi) — taaki local dev (localhost:3000)
// pe test karte waqt bhi wahin navigate ho, prod pe na chala jaye.
const GENERATOR_URL = window.location.origin + '/questionPaperGenerator';

function QuestionPaperQrCtrl() {
    const [qrDataUrl, setQrDataUrl] = useState('');
    
    // Question Paper Generator page ka link, current session ka tokenid bhi saath mein
    // (taaki mobile pe scan karne par bhi wahi (real) session use ho, DEMO_TOKEN pe depend na rahe).
    const generatorUrl = GENERATOR_URL + '?tokenid=' + encodeURIComponent(getTokenId());

    useEffect(() => {
        QRCode.toDataURL(generatorUrl, { width: 220, margin: 1 })
            .then((url) => setQrDataUrl(url))
            .catch((err) => console.error('QR error:', err));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="MainContainer" style={{ width: '100%', maxWidth: '100vw', overflowX: 'hidden', boxSizing: 'border-box' }}>
            <div style={{ background: '#3200FF', color: '#fff', padding: '16px 18px', textAlign: 'center' }}>
                <h3 style={{ margin: 0, fontSize: 20, fontWeight: 600 }}>Question Paper QR</h3>
            </div>

            <div style={{ textAlign: 'center', marginTop: 24 }}>
                {qrDataUrl && <img src={qrDataUrl} alt="QR Code" width={220} height={220} />}
                {/* <div style={{ fontSize: 13, color: '#666', marginTop: 10, maxWidth: 420, marginLeft: 'auto', marginRight: 'auto' }}>
                    Scan this QR code on your mobile, or click the button below on this device, to open the Question Paper Generator.
                </div>
                <button
                    className="btn btn-primary"
                    onClick={() => { window.location.href = generatorUrl; }}
                    style={{ marginTop: 18 }}
                >
                    Open Question Paper Generator
                </button> */}
            </div>
        </div>
    );
}

export default QuestionPaperQrCtrl;
